module.exports = __webpack_public_path__ + "img/change-folder-icon.4aae0565.svg";